import { useNavigate } from 'react-router-dom';
import { sisterConcerns } from '@/mocks/homeData';

const categoryIcons: Record<string, string> = {
  garments: 'ri-t-shirt-line',
  accessories: 'ri-vip-diamond-line',
  'printing-dyeing': 'ri-palette-line',
  packaging: 'ri-archive-line',
  'washing-laundry': 'ri-drop-line',
};

export default function SisterConcernsRow() {
  const navigate = useNavigate();

  return (
    <section id="sister-concerns" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-14 animate-on-scroll">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
            Our Network
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
            Sister Concerns
          </h2>
          <p className="text-foreground-500 max-w-[560px] mx-auto leading-relaxed">
            A vertically integrated network of manufacturing facilities under the Beaumonde Tex group, each specializing in a critical part of the apparel supply chain.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {sisterConcerns.map((company, i) => (
            <div
              key={company.slug}
              onClick={() => navigate(`/sister-concerns/${company.slug}`)}
              className="group cursor-pointer bg-white rounded-lg p-5 md:p-6 border border-[#E6EAF0] hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 animate-on-scroll opacity-0 translate-y-8 flex flex-col items-center text-center"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-50 text-accent-600 mb-4 group-hover:bg-primary-50 group-hover:text-primary-500 transition-colors duration-300">
                <i className={`${categoryIcons[company.slug] || 'ri-building-4-line'} text-xl md:text-2xl`}></i>
              </div>
              <span className="inline-block px-2.5 py-0.5 rounded-full bg-background-100 text-foreground-500 text-[10px] font-semibold uppercase tracking-wider mb-3">
                {company.category}
              </span>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 mb-2 leading-snug">
                {company.name}
              </h3>
              {/* <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 mb-4">
                {company.description}
              </p>
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-500 group-hover:text-primary-600 transition-colors duration-200 mt-auto whitespace-nowrap">
                View Details
                <i className="ri-arrow-right-line text-[10px]"></i>
              </span> */}
            </div>
          ))}
        </div>

        <div className="text-center mt-10 animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <button
            onClick={() => navigate('/sister-concerns')}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold font-heading rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            Visit All Sister Concerns
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}